/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import { FormGroup } from "react-bootstrap-3";
import TickerPickerStyle from './TickerPickerGroup.module.css';

function Bucket({ bucketValue, highlighted, bucket, onHover, onClick }) {
  const values = {
    bucket,
    bucketValue,
  };
  const className = `${TickerPickerStyle["check"]} ${highlighted ? TickerPickerStyle["highlighted"] : ""}`;
  return (
    <span
      onMouseEnter={event => onHover(event, values, true)}
      onMouseLeave={event => onHover(event, values, false)}
      onClick={event => onClick(event, values)}
      className={className}>
      {values.bucketValue}
      {" / "}
    </span>
  );
}

class TickerPickerGroup extends React.Component {
  static BUCKETS = ["accommodation", "occupation", "mealPlan", "condition"];

  constructor(props, context) {
    super(props, context);
    this.toggleAllTickers = this.toggleAllTickers.bind(this);
    this.toggleHighlightBuckets = this.toggleHighlightBuckets.bind(this);
    this.toggleTickers = this.toggleTickers.bind(this);
    this.checkTicker = this.checkTicker.bind(this);
    const checkedTickers = this.props.value || [];
    this.state = {
      tickers: this.props.tickers.map(ticker => ({
        ...ticker,
        checked: checkedTickers.indexOf(ticker.ticker) >= 0,
        highlighted: false,
      })),
    };

    const tickerMap = {};
    TickerPickerGroup.BUCKETS.forEach(bucket => {
      tickerMap[bucket] = {};
      this.state.tickers.forEach((ticker, idx) => {
        if (!tickerMap[bucket][ticker[bucket]]) {
          tickerMap[bucket][ticker[bucket]] = [];
        }
        tickerMap[bucket][ticker[bucket]].push(idx);
      });
    });

    this.state.tickerMap = tickerMap;
  }

  componentDidMount() {}

  toggleAllTickers(value) {
    const tickers = [...this.state.tickers];
    tickers.forEach(ticker => {
      ticker.checked = value;
    });
    this.setState({ tickers });
    this.props.onChange({
      value: tickers.filter(ticker => ticker.checked).map(ticker => ticker.ticker),
      field: this.props.field.fieldName,
    });
  }

  toggleHighlightBuckets(event, { bucket, bucketValue }, activate) {
    event && event.preventDefault();
    const tickers = [...this.state.tickers];
    this.state.tickerMap[bucket][bucketValue].forEach(idx => {
      tickers[idx].highlighted = activate ? bucket : false;
    });

    this.setState({ tickers });
  }

  toggleTickers(event, { bucket, bucketValue }) {
    event && event.preventDefault();
    const tickers = [...this.state.tickers];
    this.state.tickerMap[bucket][bucketValue].forEach(idx => {
      tickers[idx].checked = !!!tickers[idx].checked;
    });
    this.setState({ tickers });
    this.props.onChange({
      value: tickers.filter(ticker => ticker.checked).map(ticker => ticker.ticker),
      field: this.props.field.fieldName,
    });
  }

  checkTicker({ event, ticker, idx }) {
    const tickers = [...this.state.tickers];
    tickers[idx].checked = !!!tickers[idx].checked;
    this.setState({ tickers });

    this.props.onChange({
      value: tickers.filter(ticker => ticker.checked).map(ticker => ticker.ticker),
      field: this.props.field.fieldName,
    });
  }

  render() {
    const { field } = this.props;
    const { tickers } = this.state;
    const { toggleHighlightBuckets, toggleAllTickers, toggleTickers, checkTicker } = this;
    const { fieldName } = field;

    return (
      <div>
        <FormGroup>
          <div>
            <div>
              <button
                onClick={() => toggleAllTickers(true)}
                type="button"
                className="mb-sm mr-sm btn btn-info btn-outline">
                All
              </button>
              <button
                onClick={() => toggleAllTickers(false)}
                type="button"
                className="mb-sm mr-sm btn btn-info btn-outline">
                None
              </button>
            </div>

            <div>
              {tickers.map((ticker, idx) => (
                <div key={ticker.ticker}>
                  <div className="checkbox c-checkbox needsclick">
                    <label className="needsclick">
                      <input
                        type="checkbox"
                        className="needsclick"
                        checked={ticker.checked}
                        onChange={event => checkTicker({ event, field: fieldName, ticker, idx })}
                      />
                      <em className="fa fa-check" />

                      {TickerPickerGroup.BUCKETS.map(bucket => (
                        <Bucket
                          key={bucket}
                          bucket={bucket}
                          onHover={toggleHighlightBuckets}
                          onClick={toggleTickers}
                          bucketValue={ticker[bucket]}
                          highlighted={ticker.highlighted === bucket}
                        />
                      ))}
                      <span>({ticker.ticker})</span>
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </FormGroup>
      </div>
    );
  }
}

TickerPickerGroup.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
};

export default TickerPickerGroup;
